import * as React from 'react';

import classNames from 'classnames';

import './styles/Checkbox.scss';

type Props = {
  id: string;
  label: string;
  isChecked: boolean;
  onChange: (value: boolean) => void;
  outerCSS?: string;
  checkedIcon?: string;
  align?: 'left' | 'right';
  icon?: React.ReactNode;
};

const CheckboxRight: React.FC<Props> = (props) => {
  const {
    id,
    label,
    isChecked,
    onChange,
    icon,
    outerCSS,
    align = 'right',
    checkedIcon = 'check_box',
  } = props;
  return (
    <div className={classNames('checkbox', outerCSS, { 'align--left': align === 'left' })}>
      <input
        id={id}
        type="checkbox"
        checked={isChecked}
        onChange={(e: any) => onChange(e.target.checked)}
      />
      <label className="checkbox-label" htmlFor={id}>
        <span className="checkbox-label-content">
          {icon}
          {label}
        </span>
        {isChecked ? (
          <i className="checkbox-check material-symbols is--checked">{checkedIcon}</i>
        ) : (
          <i className="checkbox-check material-symbols">check_box_outline_blank</i>
        )}
      </label>
    </div>
  );
};

export default CheckboxRight;
